export default "__VITE_ASSET__15a359db__"